const icon = require('vue-svgicon');
icon.register({
    'caret-left': {
        width: 512,
        height: 512,
        viewBox: '0 0 512 512',
        data: `<path pid="0" d="M350.546 13.964l18.618 18.618L143.419 256l225.745 223.418-18.618 18.618L110.837 256z"/>`,
    },
});
